__turbopack_context__.v({
  "link": "TravelModeLink-module-scss-module__TGE72a__link",
});
